import { render, staticRenderFns } from "./Xxtd.vue?vue&type=template&id=748bd103&scoped=true"
import script from "./Xxtd.vue?vue&type=script&lang=js"
export * from "./Xxtd.vue?vue&type=script&lang=js"
import style0 from "./Xxtd.vue?vue&type=style&index=0&id=748bd103&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bd103",
  null
  
)

export default component.exports